/* eslint-disable no-restricted-imports */
import {
  LoadingButton as LoadingButtonBase,
  type LoadingButtonProps as LoadingButtonPropsBase,
} from "@src/appV2/redesign/system/ui-components";
/* eslint-enable no-restricted-imports */
import { type LocationState } from "history";

import { ButtonInternalLink } from "./ButtonInternalLink";

interface LoadingButtonProps extends Omit<LoadingButtonPropsBase, "LinkComponent"> {
  locationState?: LocationState;
}

export function LoadingButton(props: LoadingButtonProps) {
  return <LoadingButtonBase {...props} LinkComponent={ButtonInternalLink} />;
}
